// extracted by mini-css-extract-plugin
export default {"component":"FriendsLeft_component__9c52K"};